import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Reveal, Eyebrow } from "./MarketingUI";
import { Landmark, Workflow, LineChart, ArrowRight } from "lucide-react";

const chain = [
  { icon: Landmark, label: "Official Legislative Activity", note: "Bills, votes, amendments, committees" },
  { icon: Workflow, label: "Internal Government Workflow", note: "Assignments, analysis, alerts, monitoring" },
  { icon: LineChart, label: "Leadership Visibility", note: "Executive brief, analytics, reporting" },
];

export default function FlowNarrative() {
  const reduce = useReducedMotion();
  return (
    <section className="border-y border-brand-line bg-white py-20 sm:py-24" data-testid="flow-narrative-section">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 text-center">
        <Reveal><Eyebrow>Why GovFlowState</Eyebrow></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mx-auto mt-4 max-w-3xl font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-ink sm:text-4xl">
            Track legislation. Coordinate your team. Act with confidence.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-brand-slate">
            GovFlowState is not just another legislative search engine. It connects official legislative activity with the assignments, internal analysis, monitoring, alerts and reporting government teams need to act on it.
          </p>
        </Reveal>

        <div className="mt-12 flex flex-col items-stretch justify-center gap-4 lg:flex-row lg:items-center">
          {chain.map((c, i) => (
            <React.Fragment key={c.label}>
              <Reveal delay={0.1 * i} className="flex-1">
                <div className="h-full rounded-2xl border border-brand-line bg-[#F5F7FA] p-6 text-left" data-testid={`flow-step-${i}`}>
                  <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-navy">
                    <c.icon className="h-5 w-5 text-brand-gold" strokeWidth={1.9} />
                  </span>
                  <h3 className="mt-4 font-display text-base font-bold text-brand-ink">{c.label}</h3>
                  <p className="mt-1 text-sm leading-snug text-brand-slate">{c.note}</p>
                </div>
              </Reveal>
              {i < chain.length - 1 && (
                <motion.div
                  initial={reduce ? false : { opacity: 0 }}
                  whileInView={reduce ? {} : { opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.1 * i + 0.15 }}
                  className="flex shrink-0 items-center justify-center"
                >
                  <ArrowRight className="h-6 w-6 rotate-90 text-brand-civic lg:rotate-0" />
                </motion.div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
